export default "__VITE_ASSET__a24172b5__"